import Immutable from 'immutable';

export const State = Immutable.fromJS({
  showUserDropDown: false,
  shoppingCount: 0,
});
